

import React, { useState, useEffect, memo, useMemo, useRef } from 'react';
import ValuesStore from '../../store/values-store';
import { useSearchParams, Link, useLocation, useNavigate } from 'react-router-dom';
import utils from '../../dependencies/custom/react-utilities';
import { Space, Button, DatePicker, Card, Tooltip, Tabs } from 'antd';

import useTable from '../../hooks/table';

import useAdd from '../../hooks/add';

import Settings from '../../dependencies/custom/settings';
import { confirmAlert } from 'react-confirm-alert';
import CustomFunctions from '../../dependencies/custom/custom-functions';
import AppContainer from '../../components/container';

const GradeChangeRequest = (props) => {
    const valuesStore = ValuesStore();
    // const edit = useEdit('tables_metadata', 'table_name');//make this hook be aware of where to get tbl metadata 
    // const add = useAdd('tables_metadata', 'table_name');
    // const del = useDelete();
    const extraFiltersAddMeta = 'extraFiltersAddMeta';
    const extraFiltersAdd = useAdd(extraFiltersAddMeta, 'table_name');
    const { filters, filterTypes } = utils.generateTableFilters();
    const [dateRange, setDateRange] = useState([]);
    const navigate = useNavigate();
    const keyOverrides = { categoryAlias: 'category' };
    const [btnPermissions, setBtnPermissions] = useState({});
    const [requestType, setRequestType] = useState('grade_change');
    const [forceRenderer, setForceRenderer] = useState(false);

    //and key value that points to the table names from zustand store.    
    const table = useTable(
        {
            pagination: {
                current: 1,
                pageSize: 10,
                position: ['bottomRight'],
                hideOnSinglePage: true
            },
            filters: { ...filters },
            filterTypes: { ...filterTypes }
        },
        undefined,
        'post',
        'result',
        'totalCount',
        'id',
        { /*alias: 'LIKE', acadyr: 'LIKE', semester: 'IN', end_date: 'IN', is_active: 'IN' */ },
        { table: 'grade_change_extra', fields: ['*'] });

    // const newGradeTable = useTable(
    //     {
    //         pagination: {
    //             current: 1,
    //             pageSize: 10,
    //             position: ['bottomRight'],
    //             hideOnSinglePage: true
    //         },
    //         filters: { ...filters },
    //         filterTypes: { ...filterTypes }
    //     },
    //     undefined,
    //     'post',
    //     'result',
    //     'totalCount',
    //     'id',
    //     { /*alias: 'LIKE', acadyr: 'LIKE', semester: 'IN', end_date: 'IN', is_active: 'IN' */ },
    //     { table: 'grade_change_extra', fields: ['*'] });

    const columns = ([
        {
            title: '',
            dataIndex: 'status',
            filters: [
                {
                    text: 'Submitting',
                    value: 'submitting'
                },
                {
                    text: 'Approved',
                    value: 'approved'
                },
                {
                    text: 'Declined',
                    value: 'declined'
                }
            ],
            render: (v, r) => {
                return <>
                    {r.status === 'approved' ? <i className='fas fa-check-double text-success' /> : r.status === 'declined' ? <i className='fas fa-times text-danger' /> : <i className='fas fa-spinner text-warning' />}
                </>
            }
        },
        {
            title: 'IndexNo.',
            dataIndex: 'student_id',
            ...table.getColumnSearchProps('student_id'),
        },
        {
            title: 'Asessmt.',
            dataIndex: 'newAssessment',
            render(v, record) {
                return <Tooltip title={`Old Total Assessment: ${record?.oldAssessment}`}>
                    <label>{v}</label>
                </Tooltip>
            }
        },
        {
            title: 'Exams',
            dataIndex: 'newExams',
            render(v, record) {
                return <Tooltip title={`Old Total Exams: ${record?.oldExams}`}>
                    <label>{v}</label>
                </Tooltip>
            }
        },
        {
            title: 'Total',
            dataIndex: 'newTotalMarks',
            render(v, record) {
                return <Tooltip title={`Old Total Marks: ${record?.oldTotal}`}>
                    <label>{v}</label>
                </Tooltip>
            }
        },
        {
            title: 'AcadYr.',
            dataIndex: 'acad_year'
        },
        {
            title: 'Lecturer',
            dataIndex: 'submitted_by',
            filterSearch: true,
            render(val, record) {
                return `${val}(${record.name})`;
            }
        },
        {
            title: 'CourseCode',
            dataIndex: 'course_code',
            ...table.getColumnSearchProps('student_id'),
            render: (_, record) => {
                return `${record.course_name}(${record.course_code})`
            }
        }
    ]);

    if (btnPermissions?.show_grade_change_buttons) {
        columns.push({
            title: 'Action',
            key: 'action',
            render: (_, record) => {
                return <Tooltip title={record?.remarks}>
                    <Space size="middle">
                        <Button className='btn-successx border-0x' onClick={e => onSetGradeChangeStatus(record, 'approve', 'single')}><i className='fas fa-thumbs-up text-success' /></Button>
                        <Button className='btn-successx border-0x' onClick={e => onSetGradeChangeStatus(record, 'decline', 'single')}><i className='fas fa-thumbs-down text-danger' /></Button>
                    </Space>
                </Tooltip>
            },
        });
    }

    function setupExtraFilters() {
        setTimeout(e => {
            valuesStore.setValue(extraFiltersAddMeta, [
                {
                    id: '', table_name: 'grade_change_filters',
                    column_name: 'type', col_real_name: 'Type', type: 'jsonMultiSelect',
                    options: '{"grade_change":"Grade Change","resit":"Resit"}',
                    extra_options: '',
                    backend_visible: 1, front_visible: 0,
                    editable: 1, validator: '', icon: '', rank: 1
                },
                // {
                //     id: '', table_name: 'grade_change_filters',
                //     column_name: 'program', col_real_name: 'Program', type: 'sqlMultiSelect',
                //     options: '{"sql":"SELECT name,alias FROM programs","key":"alias","value":"name"}',
                //     extra_options: ``,
                //     backend_visible: 1, front_visible: 0,
                //     editable: 1, validator: '', icon: '', rank: 3
                // }
            ]);
            extraFiltersAdd.setTblName('grade_change_filters');
        }, 1000);
    }

    const colFilters = [
        {
            filter: 'submitted_by',
            sql: 'SELECT staff_id,name FROM admin',
            key: 'staff_id',
            value: 'name,staff_id'
        }
    ];


    async function onSetGradeChangeStatus(record, status, type) {
        confirmAlert({
            title: 'Confim grade change request',
            message: 'Action cannot be undone Click on Yes to continue. Click on No stop',
            buttons: [
                {
                    label: 'Yes',
                    onClick: () => { setGradeStatus(record, status, type) }
                },
                {
                    label: 'No',
                    onClick: () => { }
                }
            ]
        });
    }

    function setGradeStatus(record, status, type) {
        switch (status) {
            case "approve": {
                if (type === 'multiple') {
                    if (table.selectedRows.length) {
                        CustomFunctions.setGradeStatusExtra(table.selectedRows, 'approve', setForceRenderer);
                    } else {
                        utils.showNotification(undefined, 'No selection was done');
                    }
                } else {
                    CustomFunctions.setGradeStatusExtra([record], 'approve', setForceRenderer);
                }

                break;
            }
            case "decline": {
                if (type === 'multiple') {
                    if (table.selectedRows.length) {
                        CustomFunctions.setGradeStatusExtra(table.selectedRows, 'decline', setForceRenderer);
                    } else {
                        utils.showNotification(undefined, 'No selection was done');
                    }
                } else {
                    CustomFunctions.setGradeStatusExtra([record], 'decline', setForceRenderer);
                }
                break;
            }
        }
    }

    function applyFilter() {
        table.rowSelectionDebug();
        table.setSelectedRows([]);
        if (extraFiltersAdd.record?.type) {
            let values = extraFiltersAdd.record?.type.split(',').map(v => v);
            filters['grade_change_extra.type'] = values;
        }
        // if (extraFiltersAdd.record?.program) {
        //     let values = extraFiltersAdd.record?.program.split(',').map(v => v);
        //     filters['name'] = values;
        // }

        table.setTableParams(r => {
            return { ...r, filters: { ...r.filters, ...filters } };
        });

        //this is fixing a bug
        if (Object.keys(filters) <= 0) {
            table.setTableParams(r => ({ ...r, filters }));
        }
        if (dateRange?.length) {
            let startDate = dateRange[0]?.$d;
            let endDate = dateRange[1]?.$d;
            if (startDate && endDate) {
                utils.filterByDate('grade_change_extra.date_inserted', dateRange, table);
            } else {
                table.setExtraFetchParams({ type: requestType });
            }
        } else {
            table.setExtraFetchParams({ type: requestType });
        }
    }

    async function setTableDataURL() {
        //the permissions are arranged from max to min. Max perms have the highest priority
        const permList = [
            'get_grade_change_requests_extra',
            'get_submitted_grade_change_requests_extra',
        ];
        for (let i = 0; i < permList.length; i++) {
            const v = permList[i];
            const hasPerm = await utils.hasPermission(v, null, valuesStore);
            if (hasPerm) {
                table.setDataURL(`${Settings.backend}/${v}`);
                break;
            }
        }
    }

    useMemo(() => {
        console.log('looping');
        setTableDataURL();
        applyFilter();
        setupExtraFilters();
        table.setColumns(columns);
        table.setExtraFetchParams((p) => ({ ...p, type: requestType }));

        table.setColFilters(colFilters, columns, `${Settings.backend}/get_col_filters`);

        if (btnPermissions?.show_grade_change_buttons) {
            table.setAllowSelection(true);
        }

        showBtnUsingPermissions();
    }, [/*extraFiltersAdd.record*/, forceRenderer, JSON.stringify(table.extraFetchParams), btnPermissions, requestType]);


    function showBtnUsingPermissions() {
        if (Object.keys(btnPermissions) <= 0) {
            const permList = ['show_grade_change_buttons'];
            permList.forEach(async v => {
                const perm = await utils.hasPermission(v, null, valuesStore);
                setBtnPermissions(r => ({ ...r, [v]: perm }))
            });
            table.rowSelectionDebug();
        }
    }

    function theTabs() {
        return [
            {
                label: <><label className='d-none d-md-flex'>Grade Change</label></>,
                key: 'grade_change',
                children: gradeChange()
            },
            {
                label: <><label className='d-none d-md-flex'>New Grades</label></>,
                key: 'new_grade',
                children: newGrades()
            }
        ];
    }

    function gradeChange() {
        return <Card
            bordered={false}
            className="criclebox tablespace border-0 mb-24 p-2"
            title="Grade Change Requests"
            extra={
                <Space>
                    <DatePicker.RangePicker onChange={v => setDateRange(v)} value={dateRange} />
                    <Button className='btn-primary border-0' onClick={e => applyFilter()}><i className='fas fa-filter me-2' />Filter</Button>
                    <Button className='btn-info border-0' onClick={e => navigate(0)}>Clear All Filters</Button>
                    {btnPermissions?.show_grade_change_buttons && <Button className='btn-success border-0' onClick={e => onSetGradeChangeStatus(null, 'approve', 'multiple')}><i className='fas fa-check-double me-2' /> Approve All</Button>}
                    {btnPermissions?.show_grade_change_buttons && <Button className='btn-danger border-0' onClick={e => onSetGradeChangeStatus(null, 'decline', 'multiple')}><i className='fas fa-times me-2' /> Decline All</Button>}
                </Space>
            }
        >
            <div className='row'>
                <div className='col-md-12'>
                    <div className='mt-2'>
                        {extraFiltersAdd.form}
                    </div>
                </div>
                <div className='col-md-12 mt-2'>
                    {table.table}
                </div>
            </div>
        </Card>
    }

    function newGrades() {
        return <Card
            bordered={false}
            className="criclebox tablespace border-0 mb-24 p-2"
            title="New Grade Request"
            extra={
                <Space>
                    <DatePicker.RangePicker onChange={v => setDateRange(v)} value={dateRange} />
                    <Button className='btn-primary border-0' onClick={e => applyFilter()}><i className='fas fa-filter me-2' />Filter</Button>
                    <Button className='btn-info border-0' onClick={e => navigate(0)}>Clear All Filters</Button>
                    {btnPermissions?.show_grade_change_buttons && <Button className='btn-success border-0' onClick={e => onSetGradeChangeStatus(null, 'approve', 'multiple')}><i className='fas fa-check-double me-2' /> Approve All</Button>}
                    {btnPermissions?.show_grade_change_buttons && <Button className='btn-danger border-0' onClick={e => onSetGradeChangeStatus(null, 'decline', 'multiple')}><i className='fas fa-times me-2' /> Decline All</Button>}
                </Space>
            }
        >
            <div className='row'>
                <div className='col-md-12'>
                    <div className='mt-2'>
                        {extraFiltersAdd.form}
                    </div>
                </div>
                <div className='col-md-12 mt-2'>
                    {table.table}
                </div>
            </div>
        </Card>
    }

    return (
        <>
            <AppContainer
                title={'Grade Change'}
                extra={<></>}
                children={
                    <div>
                        <Tabs
                            onTabClick={e => e == 'new_grade' ? setRequestType('add_grade') : setRequestType('grade_change')}
                            items={theTabs()}
                        />
                    </div>
                }
            />           
        </>
    );
}

export default memo(GradeChangeRequest);